import React from 'react'
import { useSelector } from 'react-redux'
import { Progress } from 'components/ui'
import { RiVipCrownFill } from 'react-icons/ri'
import { RxSlash } from 'react-icons/rx'

const TitlesProgress = ({ cartView }) => {
    const subscription = useSelector((state) => state.base.common.subscription)
    const premiumTitlesCount = useSelector(
        (state) => state.checkout.titles.premiumTitlesCount
    )
    const standardTitlesCount = useSelector(
        (state) => state.checkout.titles.standardTitlesCount
    )

    return (
        <>
            <div className="flex flex-col gap-1">
                <div className="flex justify-between items-center">
                    <div className="flex justify-start items-center">
                        <RiVipCrownFill className="text-lg text-orange-400" />
                        <span className="mx-2 font-semibold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-500">
                            Premium
                        </span>
                    </div>
                    <span className="font-semibold flex justify-between items-center gap-0">
                        <span className="text-zinc-700">
                            {cartView ? (
                                premiumTitlesCount > 0 ? (
                                    <div className="flex items-center justify-between gap-2">
                                        <div>
                                            {subscription.titles
                                                ?.premiumTitlesCount || ''}
                                        </div>
                                        <div className="text-primary">
                                            + {premiumTitlesCount}
                                        </div>
                                    </div>
                                ) : (
                                    subscription.titles?.premiumTitlesCount || 0
                                )
                            ) : (
                                subscription.titles?.premiumTitlesCount || 0
                            )}
                        </span>
                        <RxSlash className="font-bold text-md text-gray-400" />
                        <span className="text-gray-400">
                            {subscription.package?.premium_num < 0 ||
                            !subscription.package?.premium_num
                                ? 'unlimited'
                                : subscription.package?.premium_num}
                        </span>
                    </span>
                </div>
                <Progress
                    color="orange-400 py-1.5"
                    percent={
                        ((subscription.titles?.premiumTitlesCount || 0) /
                            (subscription.package?.premium_num || 1000)) *
                        100
                    }
                    showInfo={false}
                />
            </div>
            <div className="flex flex-col gap-1">
                <div className="flex justify-between items-center">
                    <span className="font-semibold text-cyan-500">
                        Standard
                    </span>
                    <span className="font-semibold flex justify-around items-center gap-0">
                        <span className="text-zinc-700">
                            {cartView ? (
                                standardTitlesCount > 0 ? (
                                    <div className="flex items-center justify-between gap-2">
                                        <div>
                                            {subscription.titles
                                                ?.standardTitlesCount || ''}
                                        </div>
                                        <div className="text-primary">
                                            + {standardTitlesCount}
                                        </div>
                                    </div>
                                ) : (
                                    subscription.titles?.standardTitlesCount ||
                                    0
                                )
                            ) : (
                                subscription.titles?.standardTitlesCount || 0
                            )}
                        </span>
                        <RxSlash className="font-bold text-md text-gray-400" />
                        <span className="text-gray-400">
                            {subscription.package?.standard_num < 0 ||
                            !subscription.package?.standard_num
                                ? 'unlimited'
                                : subscription.package?.standard_num}
                        </span>
                    </span>
                </div>
                <Progress
                    color="cyan-500 py-1.5"
                    percent={
                        ((subscription.titles?.standardTitlesCount || 0) /
                            (subscription.package?.standard_num || 1000)) *
                        100
                    }
                    showInfo={false}
                />
            </div>
        </>
    )
}

export default TitlesProgress
